module.exports = __webpack_public_path__ + "img/tag3.c1233ba1.png";